import { doFetchTicketAggregationCountsFor } from './doFetchTicketAggregationCountsFor'

export function doFetchOpenTicketAggregationCountsForEachMailbox(options) {
  return dispatch => {
    dispatch(doFetchTicketAggregationCountsFor({ state: 'opened' }, options))
  }
}
